import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { getDefaultDateString } from "../components/env";
import CustomCalendar from "./CustomCalendar";

export default function PatientList({ userRole = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const currentDate =
    new URLSearchParams(location.search).get("date") || getDefaultDateString();

  const [date, setDate] = useState(currentDate);

  return (
    <>
      <Button colorScheme="blue" size="sm" onClick={onOpen}>
        📅 Schedules
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Schedules</ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0}>
            <CustomCalendar
              date={date}
              onSelectDate={(newDate) => {
                setDate(newDate);
                navigate(`/schedules?date=${newDate}`);
                onClose();
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
